import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const update = (userModel: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.appUserProfile.isUpdating) { return Promise.reject(); }

  dispatch({ type: types.UPDATE_PROFILE_REQUEST });

  return api.app.userProfile.update(userModel)
    .then((res: any) => {

      dispatch({
        type: types.UPDATE_PROFILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPDATE_PROFILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
